import React from 'react'
import error from '../../../assets/icons/icons-error.svg'
import Text from '../../text/Text'
import './ErrorModal.css'
import Help from '../../../assets/icons/help-desk-button.png'

export interface IErrorModalProps {
    text?: string
    buttonText: string
    subtitle?: string
    handleOnPress?: () => void
    whatsappButton?: boolean
    closeModal?: () => void
    content?: JSX.Element
}

export default function ErrorModal({
    text,
    buttonText,
    subtitle,
    handleOnPress,
    closeModal,
    whatsappButton = true,
    content,
}: IErrorModalProps) {
    return (
        <div className="errorModalContainer">
            <div className={'centeredIcon'}>
                <img src={error} width={100} />
            </div>
            <div style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
                {content ? (
                    content
                ) : (
                    <>
                        <div className={'title'}>
                            <Text
                                label={text}
                                variant="Body1-16 centeredTitle"
                                fontWeight={700}
                                fontSize={16}
                                color={'#565656'}
                            />
                        </div>
                        {subtitle && (
                            <Text label={subtitle} variant="Body2-14" />
                        )}
                    </>
                )}
                <div className={'centered'} style={{ marginTop: 20 }}>
                    {whatsappButton ? (
                        <img
                            src={Help}
                            style={{ marginTop: 20 }}
                            className="help-icon"
                            onClick={() =>
                                window.open(
                                    'https://amipassmerchants.zendesk.com/hc/es-419'
                                )
                            }
                        />
                    ) : (
                        <div
                            className={'buttonContinue-survey'}
                            onClick={closeModal || handleOnPress}
                            style={{ backgroundColor: '#00B744' }}
                        >
                            <a className={'ButtonMd-14'}>{buttonText}</a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
